module.exports = __webpack_public_path__ + "img/image_16.8ccb27b7.png";